import React from 'react'

import { createCanonicalPdpUrl } from '../../../../app/_components/navigation/createPdpUrl'
import { SeoMeta } from '../../../../components/SeoMeta'

export interface ProductPageMetaProps {
  colorName?: string
  description?: string
  handle: string
  image?: string
  noindex?: boolean
  seoDescription?: string
  seoTitle?: string
  title?: string
  video?: string
  isExclusive: boolean
  genderCategoryKey: string | null
}

export const ProductPageMeta: React.FC<ProductPageMetaProps> = ({
  colorName,
  description,
  handle,
  image,
  noindex,
  seoDescription,
  seoTitle: seoTitleProp,
  title,
  video,
  isExclusive,
  genderCategoryKey,
}) => {
  const seoTitle = seoTitleProp?.trim().length ? seoTitleProp : title

  const seoTitleWithColor: string | undefined = (() => {
    if (!seoTitle || !colorName) return
    return `${seoTitle} - ${colorName}`
  })()

  const titleWithColor: string | undefined = (() => {
    if (!title) return
    return `${colorName} ${title}`.trim()
  })()

  const pageTitle = seoTitleWithColor ?? titleWithColor

  const canonicalUrl = createCanonicalPdpUrl({
    productGroupHandle: handle,
    isKit: false,
    isExclusive,
    genderKey: genderCategoryKey,
  })

  return (
    <SeoMeta
      canonicalUrl={canonicalUrl}
      image={image}
      noindex={noindex}
      video={video}
      description={seoDescription}
      imageAlt={description}
      title={pageTitle}
    />
  )
}

export default ProductPageMeta
